import {fetchACHBankInfo} from "../Util/queries";
import {constructACHBankInfo} from "../Factory/factory";
import {ACH_BANK_INFO_REDUCER} from "../Reducers/achBankInfoReducer";

export const getACHBankInfo = () => async dispatch =>{
    try {
        let response = await fetchACHBankInfo();

        if (response.data) {
            let achInfoBankObj = constructACHBankInfo(response.data.bankName, response.data.last4, response.data.routingNumber, response.data.email, response.data.stripeCustomerId);
            dispatch({
                type: ACH_BANK_INFO_REDUCER,
                payload: achInfoBankObj
            })
        } else {
            dispatch({
                type: ACH_BANK_INFO_REDUCER,
                payload: null
            })
        }
    } catch (e) {
        console.error(e);
        dispatch({
            type: ACH_BANK_INFO_REDUCER,
            payload: null
        })
    }
}
